import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/user/auth.service';
import { InfopageService } from '../../../services/infopage/infopage.service';
import { ApplicationInfoModel } from '../../../models/application.model';
import { forEach } from 'angular';

@Component({
  selector: 'app-infopage',
  templateUrl: './infopage.component.html',
  styleUrls: ['./infopage.component.css']
})
export class InfopageComponent implements OnInit {

  public applicationsInfo: ApplicationInfoModel[];
  public jsonObj = null;

  show = {
    versionInfo: false
  }

  constructor (
    private authService: AuthService,
    private infoService: InfopageService
  ) {
    console.log('Infopage!!!');
  }

  ngOnInit(): void {
    console.log('Infopage Init!!!');
    this.buildVersionList();
  }

  private buildVersionList() {
    console.log('Infopage List!!!');
    this.applicationsInfo = [];

    let uniqueUrl = Array.from(this.authService.user.enabledUserApps, app => app.ms_base_url);

    uniqueUrl.push(
      'koncentro-api',
      'koncentro-auth',
      'koncentro-proxy',
      'koncentro-clustering'
    );

    uniqueUrl = uniqueUrl.filter( function (value, indice, self) {
      return (self.indexOf(value) === indice);
    });

    uniqueUrl.forEach(url => {
      this.infoService.getVersion(url).subscribe(info => {
        this.applicationsInfo.push(info);
        this.sortArrByKey(this.applicationsInfo, 'artifactId');        
      }, () => {
        this.applicationsInfo.push({artifactId : url, version: '-.-.-'});
        this.sortArrByKey(this.applicationsInfo, 'artifactId');
      });
    });
  }

  /**
   * Usata per visualizzare i dati in ordine alfabetico
   * @param arr
   * @param key
   */
  sortArrByKey(arr, key) {
    const regex = /[^A-Za-z0-9]/g;
    arr.sort(function(a, b) {
      const textA = a[key].replace(regex, "").toLowerCase();
      const textB = b[key].replace(regex, "").toLowerCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }


  createJSON(){        
    this.show.versionInfo = !this.show.versionInfo;
    if(this.jsonObj==null){
      this.jsonObj = {};
      for(let i=0; i<this.applicationsInfo.length;i++){
        let record = this.applicationsInfo[i];
        let stringKey = record.artifactId.replace("-",".");
        stringKey = stringKey.indexOf(".")>-1 ? stringKey.substring(stringKey.indexOf(".")+1,stringKey.length) : stringKey;
        let stringValue = record.version;
        this.jsonObj[stringKey] = stringValue;
      }
    }   
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/infopage/infopage.component.ts